import { useTranslation } from "react-i18next";
import { Tooltip } from "@components/Tooltip/Tooltip";
import { usePOAModal } from "@hooks/usePOAModal";
import { type IPoaSpRequest } from "@services/powersOfAttorney/types";
import { RequestedProviderBillNameCell } from "../RequestedProviderBillNameCell/RequestedProviderBillNameCell";
import { RequiredProviderBillOptions } from "../RequiredProviderBillOptions/RequiredProviderBillOptions";

interface IRequestedPOABillProps {
  POAServiceProviderRequest: IPoaSpRequest;
  fullWidthBorderTop?: boolean;
}

export const RequestedPOABill: React.FC<IRequestedPOABillProps> = ({
  POAServiceProviderRequest,
}) => {
  const { t } = useTranslation();
  const { serviceProviderName, serviceProviderRequestStateId } =
    POAServiceProviderRequest;

  const { openPOAModal } = usePOAModal();

  const statusBadge = (
    <Tooltip
      content={t("powerOfAttorney.common.statusTooltip.requestInProgress")}
    >
      <span className="text-sm text-grey-dark">
        {t(`powerOfAttorney.common.status.${serviceProviderRequestStateId}`)}
      </span>
    </Tooltip>
  );

  const openPOA = () => {
    openPOAModal({ showExistingConsent: true });
  };

  return (
    <div className="group/requested-bill flex items-center justify-between py-4 md:py-[18px] md:pr-3">
      <div className="block md:flex md:w-full md:justify-between md:gap-4">
        <RequestedProviderBillNameCell
          variant="powerOfAttorney"
          name={serviceProviderName}
          statusBadge={statusBadge}
          shouldDisplayDocumentButton={true}
          onDocumentButtonClick={openPOA}
          documentButtonTooltipContent={t(
            "bill.requestedSp.interactions.openPowerOfAttorney.tooltip",
          )}
        />
        <div className="hidden md:block">{statusBadge}</div>
      </div>
      <RequiredProviderBillOptions
        isOpenPOAButtonEnabled
        onOpenPOAClick={openPOA}
        isProviderHintEnabled
        providerHintText={t(
          "powerOfAttorney.common.statusTooltip.requestInProgress",
        )}
      />
    </div>
  );
};
